/**
 * Get configuration value from window.APP_CONFIG
 * @param {string} key - The configuration key
 * @param {*} defaultValue - The default value if key is not found
 * @returns {*} The configuration value
 */
export const getConfig = (key, defaultValue = "") => {
  if (window.APP_CONFIG && window.APP_CONFIG[key] !== undefined) {
    return window.APP_CONFIG[key];
  }
  console.warn(
    `Configuration key "${key}" not found in window.APP_CONFIG. Using default value: "${defaultValue}"`,
  );
  return defaultValue;
};

export const getLendingApiBaseUrl = () =>
  getConfig("GRIFFIN_LENDING_API_BASE_URL");

export const getCorvusBaseUrl = () => `${getLendingApiBaseUrl()}/apis/cepanel`;

export const getOMUBorrowerBaseUrl = () =>
  `${getLendingApiBaseUrl()}/apis/omu-borrower`;

const configExports = {
  getConfig,
  getLendingApiBaseUrl,
  getCorvusBaseUrl,
  getOMUBorrowerBaseUrl,
};

export default configExports;
